import { CalendarOutlined } from "@ant-design/icons";
import { Card, Segmented, Typography } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { PERIOD_PRESETS, type PeriodPreset } from "../../utils/period";

const { Text } = Typography;

export interface PeriodBarProps {
	preset: PeriodPreset;
	range: { dateFrom: string; dateTo: string };
	onChange: (next: PeriodPreset) => void;
}

function sanaMatni(sana: string): string {
	return dayjs(sana).format("DD.MM.YYYY");
}

/**
 * Markazning umumiy davri — kartalar mini-diagrammasi va «Ochish»
 * havolasi shu oraliqni oladi.
 */
export function PeriodBar({ preset, range, onChange }: PeriodBarProps) {
	const { t } = useTranslation("reports");
	const oraliq =
		range.dateFrom === range.dateTo
			? sanaMatni(range.dateFrom)
			: `${sanaMatni(range.dateFrom)} – ${sanaMatni(range.dateTo)}`;

	return (
		<Card size="small" data-period-bar>
			<div className="flex flex-wrap items-center gap-3.5">
				<Text type="secondary" className="flex items-center gap-2 text-[13px]">
					<CalendarOutlined aria-hidden="true" />
					{t("hub.period.label")}
				</Text>
				<Segmented<PeriodPreset>
					value={preset}
					onChange={onChange}
					options={PERIOD_PRESETS.map((value) => ({
						value,
						label: t(`hub.period.${value}`),
					}))}
				/>
				<span data-period-range className="font-mono text-[13px]">
					{oraliq}
				</span>
				<Text type="secondary" className="text-xs lg:ml-auto">
					{t("hub.period.note")}
				</Text>
			</div>
		</Card>
	);
}
